<template>
    <b-row>
        <b-col lg="12" class="bg-light mt-4 text-left py-3">
            <h5>Этап 1. Идентификация</h5>
            <p class="text-sm-left">Пожалуйста, подтвердите свою личность для доступа к вводу и выводу средств, а также для совершения торговых операций (это займет 3 мин).</p>
            <b-button variant="outline-secondary mt-4"  @click="showModal = true">
                <b-icon icon="eye"></b-icon> Идентификация
                Подтвердить личность
            </b-button>

            <b-modal
            id="kyc-modal"
            v-model="showModal"
            title="KYC"
            centered
            
            size="lg"
            header-bg-variant="dark"
            header-text-variant="light"
            >
            <div class="modal-body text-center p-4 bg-light rounded">
                <h5 class="mb-3">KYC Identification Process</h5>
                <p class="text-muted">
                The KYC (Know Your Customer) identification process will be done here.
                Please ensure all documents are valid and up-to-date before proceeding.
                </p>
                <b-icon icon="shield-lock" variant="info" font-scale="2"></b-icon>
            </div>
            <template #modal-footer>
                <div class="d-flex justify-content-end gap-2">
                    <b-button variant="outline-success" class="mr-2" @click="confirm">
                        <b-icon icon="check-circle-fill" class="mr-1" /> Confirmed
                    </b-button>

                    <b-button variant="outline-danger" class="mr-2" @click="decline">
                        <b-icon icon="x-circle-fill" class="mr-1" /> Declined
                    </b-button>

                    <b-button variant="outline-warning" @click="markHighRisk">
                        <b-icon icon="exclamation-triangle-fill" class="mr-1" /> High Risk
                    </b-button>
                </div>
            </template>
            </b-modal>
        </b-col>
    </b-row>
</template>
<script>
    import { EventBus } from '@/EventBus';
    export default {
        name:"Identify",
        data(){
            return {
                showModal: false,
                kycResult :{
                    status:"",
                    classification:""
                }
            }
        },
        methods: {
            confirm() {
                this.kycResult.status="verified";
                const result = Math.random() < 0.5 ? 'Retail Сlient' : 'Assessed Professional Client';
                this.kycResult.classification=result;
                EventBus.$emit('kyc-status', this.kycResult);
                this.showModal = false;
                this.$router.push('/profile');
            },
            decline() {
                this.kycResult.status="rejected";
                const result = "uknown"
                this.kycResult.classification=result;
                EventBus.$emit('kyc-status', this.kycResult);
                this.showModal = false;
                this.$router.push('/profile');
            },
            markHighRisk() {
                this.kycResult.status="pending";
                const result = "uknown"
                this.kycResult.classification=result;
                EventBus.$emit('kyc-status', this.kycResult);
                this.showModal = false;
                this.$router.push('/profile');
            }
        }
    }
</script>